import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "../../common/Select";
import TextArea from "../../common/TextArea";

function Comment({ isOpen, onHide, fields, onSave, comment }) {
  const [data, setData] = useState({
    field: "EntireForm",
    comment: "",
  });

  useEffect(() => {
    if (comment) setData({ ...comment.ObjectJSON });
  }, [comment]);

  useEffect(() => {
    document.addEventListener("focus", handleFocusChange, true);

    return () => {
      document.removeEventListener("focus", handleFocusChange, true);
    };
  }, []);

  const handleFocusChange = () => {
    if (document.activeElement.name)
      setData((d) => ({ ...d, field: document.activeElement.name }));
  };

  const handleFieldChange = ({ currentTarget: input }) => {
    setData((d) => ({ ...d, field: input.value }));
  };

  const handleCommentChange = ({ currentTarget: input }) => {
    setData((d) => ({ ...d, comment: input.value }));
  };

  const handleSaveComment = () => {
    onSave({ ...comment, ObjectJSON: data });
    setData({
      field: "",
      comment: "",
    });
  };

  const handleHideModal = (e) => {
    onHide(e);
  };

  return (
    <Modal show={isOpen} animation={false}>
      <Modal.Header>
        <Modal.Title>{comment ? "Edit Comment" : "Add Comment"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Select
          className="m-2"
          label="Comment for"
          value={data.field}
          options={fields}
          onChange={handleFieldChange}
        />
        <TextArea
          label="Comment"
          value={data.comment}
          onChange={handleCommentChange}
        />
        <div>
          <button
            className="btn btn-primary m-2"
            onClick={(event) => {
              event.preventDefault();
              handleSaveComment();
            }}
          >
            Save
          </button>
          <button className="btn btn-secondary m-2" onClick={handleHideModal}>
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Comment;
